/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum AppSchemasSubmissionsStatusEnum {
  NotStarted = 'not_started',
  Pending = 'pending',
  Completed = 'completed',
  Deleted = 'deleted'
}
